import styled from 'styled-components';

import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { Tooltip } from 'components/Toolkit/Tooltip/Tooltip';
import { InformationCircleOutlineIc } from '@dsch/dd-icons';
import { generateFinanceLink } from 'components/PageWrappers/AdDetails/helpers';

export interface PricePerMonthProps {
  className?: string;
  financeInfo: {
    title: string;
    buttonText: string;
    externalRedirectURL?: string;
    internalRedirectURL?: string;
    imageUrl: string;
    pricePerMonth: {
      priceDisplay: string;
      title: string;
      displayText: string;
      buttonText: string;
      buttonUrl: string;
    };
    external?: boolean;
  };
}

const SIoInformationCircleOutline = styled(InformationCircleOutlineIc)`
  color: ${({ theme }) => theme.colors.BLUE};
  margin-left: ${({ theme }) => theme.spacing.S4};
  cursor: pointer;
`;

const SSpan = styled.span`
  ${({ theme }) => theme.fontSize.M14};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

function createTooltip(
  text: string,
  info: PricePerMonthProps['financeInfo']['pricePerMonth'],
  link: string,
  external?: boolean,
) {
  function onTooltipClick() {
    if (external) {
      window.open(link, '_blank', 'noopener');
    } else {
      window.open(link);
    }
  }

  return (
    <>
      {text}
      <Tooltip
        title={info.title}
        subtitle={info.displayText}
        hasCloseOption={true}
        hasButton={true}
        onHandleTooltipCallback={onTooltipClick}
        buttonText={info.buttonText}
        tooltipPosition={'below'}
        displayInline={true}
      >
        <SIoInformationCircleOutline
          width="16"
          height="16"
          data-testid="info-icon"
        />
      </Tooltip>
    </>
  );
}

function PricePerMonth({ className, financeInfo }: PricePerMonthProps) {
  const redirectUrl = generateFinanceLink(financeInfo);

  return (
    <InfoTitle
      title={
        <>
          €{financeInfo?.pricePerMonth?.priceDisplay} <SSpan>p/m</SSpan>
        </>
      }
      listItems={[
        createTooltip(
          'From',
          financeInfo.pricePerMonth,
          redirectUrl,
          financeInfo.external,
        ),
      ]}
      className={className}
      flip={true}
    />
  );
}

export { PricePerMonth };
